'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  padding: ', ';\n  font-weight: ', ';\n  text-transform: ', ';\n  text-align: ', ';\n  width: ', '%;\n  max-width: ', '%;\n  min-width: ', '%;\n  flex: 1;\n  font-size: ', ';\n  cursor: ', ';\n'], ['\n  padding: ', ';\n  font-weight: ', ';\n  text-transform: ', ';\n  text-align: ', ';\n  width: ', '%;\n  max-width: ', '%;\n  min-width: ', '%;\n  flex: 1;\n  font-size: ', ';\n  cursor: ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDeviceDetect = require('react-device-detect');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Column = _styledComponents2.default.div(_templateObject, function (_ref) {
  var noPadding = _ref.noPadding,
      largePadding = _ref.largePadding,
      big = _ref.big;
  return noPadding ? '0px' : big && _reactDeviceDetect.isMobile ? '15px' : '7px ' + (largePadding ? '2' : '1') + '0px';
}, function (_ref2) {
  var bold = _ref2.bold;
  return bold ? 500 : 300;
}, function (_ref3) {
  var uppercase = _ref3.uppercase;
  return uppercase ? 'uppercase' : 'none';
}, function (_ref4) {
  var align = _ref4.align;
  return align;
}, function (_ref5) {
  var portions = _ref5.portions,
      span = _ref5.span;
  return span * (100 / portions);
}, function (_ref6) {
  var portions = _ref6.portions,
      span = _ref6.span;
  return span * (100 / portions);
}, function (_ref7) {
  var portions = _ref7.portions,
      span = _ref7.span;
  return span * (100 / portions);
}, _reactDeviceDetect.isMobile ? '16px' : '12px', function (_ref8) {
  var onClick = _ref8.onClick;
  return onClick ? 'pointer' : 'inherit';
});

Column.propTypes = {
  noPadding: _propTypes2.default.bool,
  largePadding: _propTypes2.default.bool,
  bold: _propTypes2.default.bool,
  uppercase: _propTypes2.default.bool,
  big: _propTypes2.default.bool,
  align: _propTypes2.default.oneOf(['left', 'center', 'right']),
  portions: _propTypes2.default.number,
  span: _propTypes2.default.number,
  onClick: _propTypes2.default.func
};
Column.defaultProps = {
  noPadding: false,
  largePadding: false,
  bold: false,
  big: false,
  uppercase: false,
  align: 'left',
  portions: 1,
  span: 1,
  onClick: null
};
exports.default = Column;